import React, { useEffect, useState } from "react";
import styleClasses from "../try2.module.scss";
import { Tab } from "react-bootstrap";
import AddToCombo from "./addToCombo";
import {
  ICategoriesSelection,
} from "../../../models/try2Combo";
import NavItems from "./categoriesSelection/NavItems";
import Try2CustomizationModal from "./try2CustomizationModal";
import _clonedeep from "lodash.clonedeep";
import {
  removeTemporarilyAddedPriceForItem,
  removeTry2ComboIngredients,
  try2ComboCategorySelection,
  updateTry2ComboSelectedModifiers,
} from "../../../redux/slices/itemCustomizationSlice";
import { useDispatch } from "react-redux";
import { itemBuckets } from "../../../priceCalculation/buckets";
import TabContent from "./categoriesSelection/TabContent";
import { ICustomizedItem } from "../../../models/item.model";
import * as CONSTANT from "../../../constants";

import {
  TRY_TO_COMBO_ITEM
} from "../../../constants";
import { modifiersAgainstAnItem } from "../../../priceCalculation/helper";
import { isItCreateYourOwnItem } from "../../../helpers/helperMethods";
import { createSingleRequiredModifierPaylaod } from "../../../helpers/customizedItem/customizedItem.helper";

const proteinGroup = JSON.parse(CONSTANT.REACT_APP_PROTEIN_GROUPS);

const CategoriesSelection: React.FC<ICategoriesSelection> = (props) => {
  const {
    selectedCategories,
    categories,
    selectedFilters,
    itemState,
    selectedIngredients,
    handleIngredientSelection,
    addItemtoCombo,
    sectionSelected,
    handleSyncIngredients,
    isResetTryToComboContext,
    setIsResetTryToComboContext,
    handleScroll,
    favourite,
    userId,
    noDressingHandler,
    scrollToItems,
    setScrollToItems,
    favoriteButtonHandler,
    selectedLocation,
    userType,
    itemDetails,
  } = props;
  const dispatch = useDispatch();
  const [key, setKey] = useState("");
  const [favIcon, setFavIcon] = useState<boolean>(false);
  const [requiredModalShow, setRequiredModalShow] = useState<boolean>(false);
  const [ingredientsModal, setIngredientsModal] = useState<boolean>(false);
  const [otherDressingData, setOtherDressingData] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [isInItemPresent, setIsInItemPresent] = useState<boolean>(false);
  const [isAddOnOrDoubleProtein,setIsAddOnOrDouble]=useState(false)
  // const [isSaladFirst, setIsSaladFirst] = useState<boolean>(false);
  const [
    isShowingRequiredModalOnCustomization,
    setIsShowingRequiredModalOnCustomization,
  ] = useState<boolean>(false);

  const [showProteinModalOnCombo, setShowProteinModalOnCombo] = useState(false);

  useEffect(() => {
    if (isResetTryToComboContext) {
      setKey("");
      setIsResetTryToComboContext(false);
    }
  }, [isResetTryToComboContext]);

  useEffect(() => {
    ingredientsModal && setRequiredModalShow(false);
  }, [ingredientsModal]);

  const showCustomizationModalHandler = (item) => {
    itemBuckets.createBucketCopy();
    setRequiredModalShow(true);
    handleSyncIngredients(item);
  };

  const showIngredientsModalHandler = (item: ICustomizedItem) => {
    itemBuckets.createBucketCopy();
    // handleSyncIngredients(item);
    setIngredientsModal(true);
  };

  const hideCustomizationModalHandler = () => {
    setRequiredModalShow(false);
  };

  const hideIngredientsModalHandler = (
    shouldCleanRequiredModifeirs: boolean
  ) => {
    shouldCleanRequiredModifeirs && cleaningForRequiredModifiers();
    setIngredientsModal(false);
  };
  const backButtonClick = () => {
    handleScroll();
    itemState(true);
    setKey("");
  };

  const emptySelectedItemSelectedModifiers = () => {
    //Filter slected item modifiers and consider selectedIngredients as a temporary selection
    dispatch(
      removeTry2ComboIngredients({
        modifiers: selectedIngredients,
        sectionSelected,
      })
    );
  };

  const handleSingleRequiredModifier = (item: any) => {
    let isSingleModifier = false;
    item?.items_required_modifier_groups.map(modifierGroup => {
      if(modifierGroup?.required_modifiers_groups_modifiers.length === 1)
      {
        handleIngredientSelection(createSingleRequiredModifierPaylaod(item, modifierGroup));
        isSingleModifier = true;
      }
    })
    return isSingleModifier;
  }

  const addToComboClickHandler = (item: ICustomizedItem) => {
    setShowProteinModalOnCombo(false);
    itemBuckets.addCoreModifierMemoryChip(
      sectionSelected,
      item.bucket,
      item?.items_modifier_groups
    );
    if (isItCreateYourOwnItem(item?.is_create_your_own)) {
      setSelectedItem(item);
      showIngredientsModalHandler(item);
    } else if (item?.items_required_modifier_groups.length > 0) {
      const showShowCustomizationModal = handleSingleRequiredModifier(item);
      if(showShowCustomizationModal) {
        setSelectedItem(item);
        customizeModal(item, true);
      }
      else {
        // itemBuckets.createBucketCopy();
        emptySelectedItemSelectedModifiers();
        setIsShowingRequiredModalOnCustomization(false);
        setSelectedItem(item);
        showCustomizationModalHandler(item);
      }
    } else {
      const directAddItemToCombohandler = () => {
        directAddItemToCombo(item);
      };

      showProteinItems(item, directAddItemToCombohandler);
    }
  };

  const showProteinItems = (
    item: any,
    directaddToComboOrHandleIngerdientModal: (...args: any) => any,
    fromCustomize?: boolean
  ) => {
    const showProtein = item.core_modifiers?.filter((mod) =>
      proteinGroup.includes(mod.modifier_group_id)
    );
    const showOthreProtein = item.items_modifier_groups?.filter((mod) =>
      proteinGroup.includes(mod.id)
    );

    if(showProtein?.length==0 && showOthreProtein?.length > 0){
      setIsAddOnOrDouble(true)
    }else {
      setIsAddOnOrDouble(false)
    }


    if (showProtein?.length > 0) {
      fromCustomize ?  setIsShowingRequiredModalOnCustomization(true) : setIsShowingRequiredModalOnCustomization(false);
      const newItem = _clonedeep(item);
      newItem.items_required_modifier_groups = showProtein;
      setShowProteinModalOnCombo(true);
      setSelectedItem(newItem);
      handleSyncIngredients(newItem);
      setRequiredModalShow(true);
    } 
    else if (showOthreProtein?.length > 0) {
      fromCustomize ?  setIsShowingRequiredModalOnCustomization(true) : setIsShowingRequiredModalOnCustomization(false);
      const newItem = _clonedeep(item);
      setShowProteinModalOnCombo(true);
      setSelectedItem(newItem);
      handleSyncIngredients(newItem);
      setRequiredModalShow(true);
    } 
    else {
      directaddToComboOrHandleIngerdientModal();
    }
  };

  const customizeModal = (item: ICustomizedItem, isAutoSelectModifiers=false) => {

    itemBuckets.addCoreModifierMemoryChip(
      sectionSelected,
      item.bucket,
      item?.items_modifier_groups
    );
    emptySelectedItemSelectedModifiers();
    setShowProteinModalOnCombo(false);

    if (
      isItCreateYourOwnItem(item?.is_create_your_own)
    ) {
      setSelectedItem(item);
      showIngredientsModalHandler(item);
    } else if (item?.items_required_modifier_groups.length > 0 && !isAutoSelectModifiers) {
      setIsShowingRequiredModalOnCustomization(true);
      setSelectedItem(item);
      showCustomizationModalHandler(item);
    } else {
    handleSyncIngredients(item);

      // const showDirectIngerdientModal = () => {
        showIngredientsModalHandler(item);
        setSelectedItem(item);
      // };

      // showProteinItems(item, showDirectIngerdientModal, true);
    }
  };

  const handleCustomizationModal = (item) => {
    let showCustomizationModal = false;
    if (item?.items_required_modifier_groups.length > 0) {
      showCustomizationModal = handleSingleRequiredModifier(item);
    }
    customizeModal(item, showCustomizationModal);
}

  const addItemtoComboClick = () => {
    if (isShowingRequiredModalOnCustomization) {
      showIngredientsModalHandler(selectedItem);
    } else {
      // this is sync that allow to sync the direct add item
      // handleSyncIngredients(selectedItem);
      // addSelectedIngredients(selectedItem)
      hideCustomizationModalHandler();
      backButtonClick();
      addItemtoCombo(selectedItem);
    }
  };

  //   const addSelectedIngredients = (item) => {
  //     for (let index = 0; index < item?.is_selected?.length; index++) {
  //       handleIngredientSelection(
  //       createPayloadForSelectedSingleItemModifier(item?.is_selected[index])
  //       );
  //   }
  // };

  const directAddItemToCombo = (item) => {
    handleSyncIngredients(item);
    // addSelectedIngredients(item)
    backButtonClick();
    addItemtoCombo(item);
  };

  const addCustomizeItemtoComboClick = () => {
    setOtherDressingData(false);
    hideCustomizationModalHandler();
    backButtonClick();
    addItemtoCombo(selectedItem);
  };

  const removeSelectedIngredients = (selectedCustomizeData, id) => {
    dispatch(
      removeTry2ComboIngredients({
        modifiers: selectedCustomizeData,
        sectionSelected: id,
      })
    );
  };

  const cleaningForRequiredModifiers = () => {
    const itemId: any = sectionSelected;
    if (!otherDressingData) {
      setIsInItemPresent(false);
    }
    setOtherDressingData(false);
    itemBuckets.resetCopyComboBucket();
    dispatch(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.discardBucketChanges(sectionSelected),
        item: sectionSelected,
      })
    );
    dispatch(
      updateTry2ComboSelectedModifiers({
        itemModifiers: modifiersAgainstAnItem({
          itemType: TRY_TO_COMBO_ITEM,
          itemId,
        }),
        itemId,
      })
    );
  };

  return (
    <>
      <div
        className={`${styleClasses.Menu_items_wrapper} Menu-items-wrapper try2-items-wrapper`}
      >
        <h6
          className={
            key
              ? "d-none"
              : "text-uppercase mb-sm-4 text-start text-sm-center d-none d-md-block"
          }
        >
          Select A category
        </h6>
        <h6
          className={
            key
              ? "d-none"
              : "mb-sm-4 text-start f-s18 d-md-none ls-normal font-Cls"
          }
        >
          Choose Your {sectionSelected === "1" ? "First" : "Second"} Item
        </h6>
        <Tab.Container
          id="left-tabs-example"
          activeKey={key}
          onSelect={(k) => {
            handleScroll();
            const selected = categories.find(
              (category) => category.id === parseInt(k)
            );
            setKey(k);
            setShowProteinModalOnCombo(false)
            dispatch(
              try2ComboCategorySelection({
                selected: { ...selected },
                sectionSelected,
              })
            );
          }}
        >
          {!key && (
            <NavItems
              categories={categories}
              selectedCategories={selectedCategories}
              itemState={(state) => {
                setScrollToItems(true);
                itemState(state);
              }}
            />
          )}
          <TabContent
            categories={categories}
            selectedFilters={selectedFilters}
            userId={userId}
            userType={userType}
            backButtonClick={backButtonClick}
            favButtonHandler={favoriteButtonHandler}
            customizeModal={handleCustomizationModal}
            addToComboClickHandler={addToComboClickHandler}
            favIcon={favIcon}
            favourite={favourite}
            sectionSelected={sectionSelected}
            scrollToItems={scrollToItems}
            setScrollToItems={setScrollToItems}
            itemDetails={itemDetails}
          />
        </Tab.Container>
      </div>
      <AddToCombo
        showCustomizationModal={requiredModalShow}
        closeCustomizationModal={hideCustomizationModalHandler}
        requiredModifierGroups={selectedItem?.items_required_modifier_groups}
        selectedIngredients={selectedIngredients}
        handleIngredientSelection={handleIngredientSelection}
        addItemtoCombo={addItemtoComboClick}
        sectionSelected={sectionSelected}
        itemName={selectedItem?.name}
        selectedItem={selectedItem}
        noDressingHandler={noDressingHandler}
        isShowingRequiredModalOnCustomization={
          isShowingRequiredModalOnCustomization
        }
        otherDreesingState={{ otherDressingData, setOtherDressingData }}
        isInItemPresentState={{ isInItemPresent, setIsInItemPresent }}
        cleaningForRequiredModifiers={cleaningForRequiredModifiers}
        showProteinModalOnCombo={showProteinModalOnCombo}
        isSaladFirstSelection={parseInt(sectionSelected) == 2 ? true : false}
        isAddOnOrDoubleProtein={isAddOnOrDoubleProtein}
      />

      {ingredientsModal && <Try2CustomizationModal
        showCustomizationModal={ingredientsModal}
        closeCustomizationModal={hideIngredientsModalHandler}
        modifierGroups={selectedItem?.items_modifier_groups}
        selectedIngredients={selectedIngredients}
        handleIngredientSelection={handleIngredientSelection}
        coreModifiers={selectedItem?.core_modifiers}
        requiredModifiers={
          showProteinModalOnCombo
            ? []
            : selectedItem?.items_required_modifier_groups
        }
        addItemtoComboClick={addCustomizeItemtoComboClick}
        handleSyncIngredients={handleSyncIngredients}
        selectedItem={selectedItem}
        itemName={selectedItem?.name}
        isCreateYourOwnItem={selectedItem?.is_create_your_own}
        sectionSelected={sectionSelected}
        removeSelectedIngredients={removeSelectedIngredients}
        currentEditItem={sectionSelected}
        noDressingHandler={noDressingHandler}
        showProteinModalOnCombo={showProteinModalOnCombo}
      />}
    </>
  );
};

export default CategoriesSelection;
